module.exports = __webpack_public_path__ + "img/wallet-ck.8a640294.png";